import React from "react";
import styles from "./Style.module.css";
import { Minus, Plus } from "lucide-react";

export const Counter = ({ 
  customeClass,
  isCounterVisible, 
  count, 
  handleShowCounter, 
  handleIncrement, 
  handleDecrement, 
  disabled
}) => {
  return (
    <div className={styles.toggleCounter}>
      {isCounterVisible ? (
        <div className={styles.counterContainer}>
          <button
          type="button"
          className={`${styles.minus} btn`} 
          onClick={handleDecrement} 
          title="Decrement"
          > <Minus size={20} color="var(--Neutral900)" /></button>
          <span className={`${styles.count} btn`}>{count}</span>
          <button
          type="button"
          className={`${styles.plus} btn ${disabled ? styles.disabled : ''}`} 
          onClick={handleIncrement} 
          title="Increment"
          > <Plus size={20} color="var(--Neutral900)" /></button>
        </div>
      ) : (
        <button
        type="button"
        className={`${styles.addButton} btn ${disabled ? styles.disabled : ''}`} 
        onClick={handleShowCounter}
        title="Add"
        > <Plus size={20} color={customeClass ? 'var(--Neutral900)' : 'var(--PrimaryColor800)'} /></button>
      )}
    </div>
  );
};
